export default __webpack_public_path__ + "static/media/IconDesc_SprintingStilts.256.be097484.png";